/**
 * PrivacyOptionRow — a single selectable option row in the Privacy card.
 *
 * Rendered twice ("Private" / "Members"). The selected row gets a teal
 * border + a check icon. Functionally a single-select within the
 * `role="radiogroup"` wrapper that PrivacyCard renders around the rows;
 * each row is a toggle-button (`aria-pressed`) per the Community CLAUDE.md
 * carve-out (interactive controls use `components/Button`, not raw `<button>`).
 *
 * @route /profile/edit
 * @parent PrivacyCard
 */

import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../../../../../Button/index'
import Check from '../../../../../Icon/icons/Check/index'

const CLS = 'community-profile-settings'

export interface PrivacyOptionRowProps {
  title: React.ReactNode
  description: React.ReactNode
  selected: boolean
  onSelect: () => void
}

function PrivacyOptionRow ({
  title,
  description,
  selected,
  onSelect,
}: PrivacyOptionRowProps) {
  return (
    <Button
      type={BUTTON_TYPES.GHOST}
      role="radio"
      aria-checked={selected}
      className={`${CLS}__privacy-option${selected ? ` ${CLS}__privacy-option--selected` : ''}`}
      onClick={onSelect}
    >
      <span className={`${CLS}__privacy-option-text`}>
        <span className={`${CLS}__privacy-option-title`}>{title}</span>
        <span className={`${CLS}__privacy-option-desc`}>{description}</span>
      </span>
      {selected && (
        <Check size="20px" className={`${CLS}__privacy-option-check`} />
      )}
    </Button>
  )
}

export default PrivacyOptionRow
